import type { Offer } from '@libs/common-types';

// The Loyalty API owns per-member state and activation identifiers and sends '' for merchandising
// fields it has no value for, so only these keys may override the Contentful offer.
export function applyMemberState(contentfulOffer: Offer, loyaltyOffer: Offer): Offer {
    return {
        ...contentfulOffer,
        activationPromoId: loyaltyOffer.activationPromoId,
        intType: loyaltyOffer.intType,
        isActivatable: loyaltyOffer.isActivatable,
        isActivated: loyaltyOffer.isActivated,
        loyaltyId: loyaltyOffer.loyaltyId,
        memberDescriptor: loyaltyOffer.memberDescriptor,
        memberGroup: loyaltyOffer.memberGroup,
        promoExternalReference: loyaltyOffer.promoExternalReference || contentfulOffer.promoExternalReference,
        promotionId: loyaltyOffer.promotionId ?? contentfulOffer.promotionId,
        transactionType: loyaltyOffer.transactionType,
        version: loyaltyOffer.version,
    };
}
